/* eslint-disable i18next/no-literal-string --
   Não traduzido DE PROPÓSITO: quem lê esta tela é quem administra o realm, e o
   console do Keycloak (para onde o texto manda a pessoa) está em inglês. Traduzir
   as instruções para EN e manter a UI em pt-BR seria pior que não traduzir. */
import { createFileRoute } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'

import { useAuthStore } from '@/shared/auth/auth-store'
import { userManager } from '@/shared/auth/oidc'
import { Button } from '@/shared/ui/button'

export const Route = createFileRoute('/auth/config-error')({
  component: ConfigError,
})

/**
 * Tela de diagnóstico do realm.
 *
 * Existe porque o modo de falha aqui é cruel: sem o mapper de Audience ou sem o
 * claim tenant_id, o token é válido, o login funciona, e então TODA chamada à
 * API devolve 401 com code `invalid_token` — o mesmo de um token corrompido.
 * Sem esta tela, o sintoma seria "entrei e nada carrega".
 *
 * Os textos vêm de preflightClaims e trazem o passo a passo no Keycloak. Não
 * são traduzidos de propósito: quem lê isto é quem administra o realm, e o
 * console do Keycloak está em inglês.
 */
function ConfigError() {
  const problems = useAuthStore((s) => s.problems)

  return (
    <div className="bg-canvas min-h-dvh px-6 py-12">
      <div className="mx-auto flex max-w-2xl flex-col gap-5">
        <div className="flex items-start gap-3">
          <AlertTriangle className="text-caution mt-0.5 size-5 shrink-0" aria-hidden />
          <div className="flex flex-col gap-1">
            <h1 className="text-ink text-xl font-semibold">Autenticação configurada pela metade</h1>
            <p className="text-ink-muted text-sm">
              Você entrou, mas o token emitido não atende ao que a API exige. Corrija no Keycloak e
              entre de novo.
            </p>
          </div>
        </div>

        {problems.map((p) => (
          <div key={p.code} className="border-line bg-surface rounded-lg border p-4">
            <p className="text-ink mb-2 font-mono text-xs font-semibold">{p.code}</p>
            <pre className="text-ink-muted font-sans text-sm whitespace-pre-wrap">{p.detail}</pre>
          </div>
        ))}

        <div>
          <Button
            variant="secondary"
            onClick={() => {
              void userManager.signoutRedirect()
            }}
          >
            Sair
          </Button>
        </div>
      </div>
    </div>
  )
}
